export default __webpack_public_path__ + "static/media/6.50537ac5.svg";